import { MiApplicationType } from 'constants/loanApplication';
import { miApplicationTypeOptions } from 'constants/options';

export const COMPANY_DEFAULT_MI_PROVIDER_OPTION = {
  name: 'Company default (preferred MI provider)',
  value: null,
};

export const DEFAULT_MI_APPLICATION_TYPE_OPTION = {
  name: 'Delegated (default)',
  value: null,
};

export const miApplicationTypeSelectOptions = [
  DEFAULT_MI_APPLICATION_TYPE_OPTION,
  ...miApplicationTypeOptions.filter(({ value }) => value !== MiApplicationType.DELEGATED),
];
